import Sider from "antd/es/layout/Sider";
import React from "react";
import {useChatbotContext} from "@components/Chatbot/context";
import {isAIMessage, isNotDefaultIntroMessage} from "@components/Chatbot/utils";
import PlanEditorPanel from "@components/Chatbot/PlanEditor";
import {BsGear} from "react-icons/bs";
import dayjs from "dayjs";
import {IoMdClose} from "react-icons/io";

const MessageInfoDrawer = () => {
    const {
        drawerOpen,
        setDrawerOpen,
        selectedMessage
    } = useChatbotContext();

    if (!selectedMessage) {
        return <></>;
    }

    const getPrintedTimestamp = (unixTimestamp) => {
        return dayjs.unix(unixTimestamp).format('MMM DD - hh:mm A');
    }

    return (
        <Sider
            className="chat-drawer-container"
            collapsible
            collapsed={!drawerOpen}
            trigger={null}
            collapsedWidth={0}
            width={"30vw"}
        >
            {/* Message Key Info */}
            <div className="message-drawer-header">
                <IoMdClose
                    className="message-drawer-close-icon"
                    onClick={() => setDrawerOpen(false)}
                />
                <p className="message-drawer-header-title">
                    AI Response
                </p>
                <p className="message-drawer-header-subtitle">
                    {getPrintedTimestamp(selectedMessage?.created)}
                </p>
                <p className="message-drawer-header-text">
                    <span>Message: </span> {selectedMessage?.content?.message}
                </p>
            </div>
            <p className="message-drawer-plan-editor-instructions">
                View and edit the parameters for this AI response.
            </p>
            {
                /* Plan Editor */
                selectedMessage && isAIMessage(selectedMessage) && isNotDefaultIntroMessage(selectedMessage)
                    ? <PlanEditorPanel
                        message={selectedMessage}
                        defaultCollapsed={false}
                    />
                    : <></>
            }
        </Sider>
    )
}

export default MessageInfoDrawer;